<!-- Three-dot separator: visually splits this aggregate "Close All / Chosen" card from the individual
     per-hedge cards above it (owner sketch). -->
<div class="aggregate-separator" aria-hidden="true">
  <span></span><span></span><span></span>
</div>

<div class="close-all-card"
     [class.previewed]="this.aggregateState.previewed"
     [class.applied]="this.aggregateState.applied"
     [class.expanded]="this.expanded">

  <!-- Title bar (always visible; click toggles expand): name (left) + summed ledger price (right).
       No short description, no codified legs — the collapsed aggregate is just name + price (owner). -->
  <div class="title-bar" (click)="this.toggleExpanded()">
    <span class="name" [title]="this.title">{{ this.title }}</span>
    <span class="price"
          [class.credit]="this.summedLedgerPrice > 0"
          [class.debit]="this.summedLedgerPrice < 0">{{ this.formatMoney(this.summedLedgerPrice) }}</span>
  </div>

  <!-- Expanded detail: description + one sub-section PER hedge + a SINGLE shared action row. -->
  <div class="detail" *ngIf="this.expanded">

    <div class="full-description">{{ this.descriptionLine }}</div>

    <div class="hedge-section" *ngFor="let sol of this.solutions">
      <div class="hedge-name">{{ this.hedgeName(sol) }}</div>
      <table class="legs">
        <thead>
          <tr><th>Action</th><th>Instrument</th><th>Qty</th><th>Price</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let leg of this.sortedLegs(sol)">
            <td>{{ leg.action }}</td>
            <td>{{ this.instrumentName(leg) }}</td>
            <td class="qty">{{ this.signedQuantity(leg) }}</td>
            <td class="price"
                [class.credit]="this.legSignedPrice(leg) > 0"
                [class.debit]="this.legSignedPrice(leg) < 0">{{ this.formatMoney(this.legSignedPrice(leg)) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total-row">
            <td colspan="3">Total (Order Price)</td>
            <td class="price"
                [class.credit]="this.hedgeOrderPrice(sol) > 0"
                [class.debit]="this.hedgeOrderPrice(sol) < 0">{{ this.formatMoney(this.hedgeOrderPrice(sol)) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div class="actions">
      <dx-button [text]="this.previewLabel" [disabled]="this.previewDisabled" [hint]="this.previewBlockedHint" (onClick)="this.onPreview()" width="100%"></dx-button>
      <dx-button [text]="this.applyLabel" [disabled]="this.applyDisabled" (onClick)="this.onApply()" width="100%"></dx-button>
      <dx-button text="Transactions" [disabled]="this.transactionsDisabled" (onClick)="this.onTransactions()" width="100%"></dx-button>
    </div>

    <!-- M8 (CR-20260720-001): compliance disclaimer under the shared action row. This aggregate card
         has ONE action row covering every hedge section above it, so ONE disclaimer here covers the
         whole aggregate — matching the per-solution card's placement. Expanded-detail only. Text is
         the SHARED constant (copilot-shared/copilot-disclaimer.ts). -->
    <div class="card-disclaimer" data-element="card-disclaimer" *ngIf="this.disclaimerEnabled"><span class="disclaimer-label">{{ this.disclaimer.label }}</span>: {{ this.disclaimer.text }}</div>

  </div>

</div>

<!-- Aggregate Transactions popup (its own instance): one Before/Transaction/After block per hedge. -->
<ets-hg-copilot-transactions-popup></ets-hg-copilot-transactions-popup>
